import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerDeactivatedService } from '../../servicios/customer-deactivate.service';
import { AutoUnsubscribe } from '../../../../../../../core/decorators/auto-unsubscribe';
let DesactivarCustomerModalComponent = class DesactivarCustomerModalComponent {
    constructor(_customerDeactivatedService, translateService, toastr) {
        this._customerDeactivatedService = _customerDeactivatedService;
        this.translateService = translateService;
        this.toastr = toastr;
        this.modalClose = new EventEmitter();
    }
    ngOnInit() { }
    closeModal(datos) {
        if (datos) {
            const parametros_In = {
                customerID: this.dataCustomer.CustomerId
            };
            this.deactivarSubscription = this._customerDeactivatedService.post(JSON.stringify(parametros_In))
                .subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    if (auxdata.Data) {
                        this.translateService.get('genericos.toastr.successfulDesactivar').subscribe(text => {
                            this.toastr.success(text);
                            this.modalClose.emit(auxdata.Data);
                        });
                    }
                    else {
                        this.translateService.get('genericos.toastr.errorDesactivar').subscribe(res => {
                            this.toastr.error(res);
                        });
                        this.modalClose.emit('cerrar');
                    }
                }
                else {
                    this.error = data.Warning.Content;
                    this.code = data.Warning.Title;
                    this.translateService.get('genericos.toastr.errorDesactivar').subscribe(res => {
                        this.toastr.error(res);
                    });
                    this.modalClose.emit('cerrar');
                }
            });
        }
        else {
            this.modalClose.emit('cerrar');
        }
    }
};
DesactivarCustomerModalComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [CustomerDeactivatedService,
        TranslateService,
        ToastrService])
], DesactivarCustomerModalComponent);
export { DesactivarCustomerModalComponent };
